import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TipoPagamentoDetalharComponent } from "./tipo-pagamento-detalhar.component";
import { TipoPagamentoDetalharRoutingModule } from "./tipo-pagamento-detalhar-routing.module";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";




@NgModule({
    imports: [
        CommonModule,
        TipoPagamentoDetalharRoutingModule,
        FormsModule,
        TableModule,
        InputTextModule,
        ButtonModule,
        MessagesModule,
        ProgressSpinnerModule

    ],
    declarations: [TipoPagamentoDetalharComponent]
})
export class TipoPagamentoDetalharModule { }
